import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-description-popup',
  templateUrl: './description-popup.component.html',
  styleUrls: ['./description-popup.component.scss']
})
export class DescriptionPopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DescriptionPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data
    ) { }

  ngOnInit() {
  }

}
